import { apiClient, getHeaders } from '@/services/axiosConfig'
export default {
  getLocation (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/addresses/geocode',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getOptCity (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/user-locations/search',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getCurrentCity (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/user-locations/get-current-city',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  }
}
